require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /Users/kristinberlehner/sites/mardens/wp-content/themes/mardens/node_modules/core-js/modules/es7.symbol.async-iterator.js
// module id = 337
// module chunks = 0